export default __webpack_public_path__ + "e152f6ed454b5889ab39cf31fd1a0da0.png";